
import './Header.css';
function HeaderLike () {

    return( 
    <div className='header-like'>
        <section id="bio">
        <header className="portfolio-header">
            
                <div className="portfolio-header-right">

                    <a href="#bio">Who Am I</a>
                    <a href="#professional-experience">Professional Experience</a>
                    <a href="#academic-experience">Academic Experience</a>
                    <a href="#projects">Projects</a>
                    <a href="#scientific-research">Scientific Research</a>
                    <a href="#volunteering">Volunteering</a>
                </div>
        </header>

        </section>
    </div>
    );
};

export default HeaderLike;
